import * as React from "react"
import {Skeleton} from "@mui/material";

import { TitleWithPopover, AppTableSeeker } from "@components";
import {useShareOfSearchRedirect} from "../@hooks";
import {
	shareOfSearchCurrentData,
	shareOfSearchCurrentTabNormalize,
	shareOfSearchIsBrandCurrent,
	shareOfSearchIsCategoryCurrent,
	shareOfSearchIsCountryCurrent,
	shareOfSearchIsRetailerCurrent,
	isLoadingShareOfSearch
} from "../@signals";
import ShareOfSearchActions from "./Actions";
import {countryColumn, groupedColumn, retailerColumn, scoreColumn, valueColumn} from "./columns";


export default function ShareOfSearchTable() {
	const { goToKeywordDetails } = useShareOfSearchRedirect()

	if (isLoadingShareOfSearch.value) return <Skeleton variant="rectangular" height={500} />

	return <AppTableSeeker
		data={shareOfSearchCurrentData.value}
		title={<TitleWithPopover title={`Digital shelf KPIs by ${shareOfSearchCurrentTabNormalize.value}`} />}
		columns={[
			...shareOfSearchIsCountryCurrent.value ? [countryColumn()] : [],
			...shareOfSearchIsRetailerCurrent.value ? [retailerColumn()] : [],
			...shareOfSearchIsCategoryCurrent.value ? [groupedColumn('category', 'Category')] : [],
			...shareOfSearchIsBrandCurrent.value ? [groupedColumn('brand', 'Brand')] : [],
			scoreColumn(),
			valueColumn('brandInTitle', 'Fragrances', goToKeywordDetails),
			valueColumn('brandInDesc', 'Perfume', goToKeywordDetails),
			valueColumn('descriptionLength', 'Cologne', goToKeywordDetails),
			valueColumn('images', 'Aromas', goToKeywordDetails),
			valueColumn('video', 'Scent', goToKeywordDetails),
			valueColumn('ratingReviews', 'Aromatherapy', goToKeywordDetails),
			valueColumn('stock', 'Essential oils', goToKeywordDetails),
			valueColumn('shareOfSearch', 'Fragrance notes', goToKeywordDetails),
			valueColumn('shareOfBrowse', 'Perfume bottles', goToKeywordDetails)
		]}
		options={{
			setTableProps: () => ({ sx: {
				".MuiButtonBase-root": {
					fontWeight: 'normal',
				}
			}}),
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			customToolbar: () => <ShareOfSearchActions />
		}}
	/>
}